import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useAzbot } from "../lib/Azbot.js";

const Scanfree = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [currentLang, setCurrentLang] = useState("en"); // Idioma actual

  // Configuración por defecto
  const defaultConfig = {
    exchange: "https://api.binance.com/",
    marketType: "api/v3",
    signalBuy: true,
    signalSell: false,
    coinBase: "usdt",
    symbolGroup: "top50",
  };

  // Obtener la configuración del usuario o usar la configuración por defecto
  const userConfig = user ? { ...defaultConfig, ...user.config } : defaultConfig;
  const {
    scanning,
    scanFrequency,
    currentSymbol,
    userIntervals,
    toggleScan,
    stopScan,
    resetScan,
    updateSliderValue,
    toggleInterval,
    toggleGroup,
  } = useAzbot(null);

  // Verificar la sesión del usuario al montar el componente
  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const storedUser = sessionStorage.getItem("user");
        if (storedUser) setUser(JSON.parse(storedUser)); // Establecer el usuario actual
      } catch (error) {
        console.error("Error al cargar la sesión del usuario:", error);
        sessionStorage.removeItem("user"); // Limpiar sessionStorage en caso de error
      } finally {
        setLoading(false); // Detener el loader
      }
    };

    checkUserSession();
  }, [navigate]);

  // Muestra el loader mientras se verifica la sesión
  if (loading) return <p>Cargando...</p>; // Puedes reemplazar esto con un componente Loader

  // Diccionario de idiomas
  const translations = {
    en: { scan: "Scan", scanning: "Scanning..." },
    es: { scan: "Escanear", scanning: "Escaneando..." },
  };

  
  // Función para obtener el texto del botón de escaneo
  const getButtonText = () => scanning ? translations[currentLang].scanning : translations[currentLang].scan;

  return (
    <div>
      <Header user={user} />
      <main>
        <nav className="pt-2 px-4 border-bottom" style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/home">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Free Scan</li>
          </ol>
        </nav>

        <div className="accordion p-1 m-1 mt-0" id="accordionPanelsStayOpen">
          <div className="accordion-item" id="auto_trade_settings" style={{ color: "#000", backgroundColor: "#cdcdcd" }}>
            <h2 className="accordion-header">
              <button className="fs-4 fw-2 accordion-button show collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panel_settings" aria-expanded="false" aria-controls="panel_settings">
                <i className="bi bi-gear fs-3 mx-2"></i> Settings
              </button>
            </h2>
            <div id="panel_settings" className="accordion-collapse collapse">
              <div className="accordion-body p-2">
                <form id="settingsForm">
                  <div className="mb-4">
                    <div className="horizontal-form">
                      <div className="form-group">
                        <label htmlFor="exchangeSource" className="form-label">Exchange Source</label>
                        <select className="form-select" id="exchangeSource" defaultValue={userConfig.exchange}>
                          <option value="https://api.binance.com/">Binance.com</option>
                          <option value="https://api.binance.us/" disabled>Binance.us</option>
                          <option value="https://api.poloniex.com/" disabled>Poloniex.com</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="marketType" className="form-label">Market</label>
                        <select className="form-select" id="marketType" defaultValue={userConfig.marketType}>
                          <option value="api/v3">SPOT</option>
                          <option value="fapi/v1">FUTURES</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="signal_buy" className="form-label">Search Signal for</label>
                        <div className="form-range" style={{ fontWeight: "bold", padding: "0px", fontSize: "1.2em" }}>
                          <input type="checkbox" className="mx-2" defaultChecked={userConfig.signalBuy} name="signal_buy" id="signal_buy" />
                          <span className="buy">BUY</span>
                          <input type="checkbox" className="" style={{ marginLeft: "20px" }} defaultChecked={userConfig.signalSell} name="signal_sell" id="signal_sell" />
                          <span className="sell">SELL</span>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="stable_coinbase" className="form-label">Coin Base</label>
                        <select className="form-select" id="stable_coinbase" defaultValue={userConfig.coinBase}>
                          <option value="usdt">USDT</option>
                          <option value="usdc">USDC</option>
                          <option value="fdusd">FDUSD</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="symbol_group" className="form-label">Symbols</label>
                        <select className="form-select" id="symbol_group" defaultValue={userConfig.symbolGroup}>
                          <option value="all">ALL</option>
                          <option value="top50">TOP 50</option>
                          <option value="top100">TOP 100</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="symbol_button" className="form-label"></label>
                        <div className="form-range">
                          <button id="symbol_button" type="button" className="btn btn-dark">Manage Groups</button>
                        </div>
                      </div>
                      <div className="form-group m-0 p-0" style={{ height: "auto" }}>
                        <label htmlFor="intervals2" className="form-label pt-1">Intervals</label>
                        <div className="form-control p-0 m-0" style={{ justifyContent: "left", alignItems: "left", border: "0px", fontWeight: "bold", fontSize: "1em" }}>
                          <div className="d-flex flex-wrap m-0 p-0">
                            {userIntervals.map((interval) => (
                              <button key={interval} type="button" className={`btn interval-btn ${userIntervals.includes(interval) ? "active" : ""}`} onClick={() => toggleInterval(interval)}>
                                {interval}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 align-items-center center">
                        <button type="button" className="btn btn-secondary me-1" onClick={() => toggleGroup("long-term")}>Long-Term</button>
                        <button type="button" className="btn btn-secondary me-1" onClick={() => toggleGroup("mid-term")}>Mid-Term</button>
                        <button type="button" className="btn btn-secondary" onClick={() => toggleGroup("short-term")}>Short-Term</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="card m-1">
          <h2 className="text-center border-bottom"><div className="p-2">Control Panel</div></h2>
          <div className="card-body p-2 m-0">
            <div className="text-center py-1">
              <div style={{ width: "100%" }}>
                <div style={{ margin: "0 auto", textAlign: "center", minWidth: "300px", maxWidth: "500px", width: "100%" }}>
                  <button onClick={toggleScan} className={`btn btn-warning p-3 shadow mb-3 rounded ${scanning ? "blinking" : ""}`} style={{ color: "#000", fontWeight: "bold", fontSize: "1.2em", minWidth: "160px" }}>
                    {getButtonText()}
                  </button>
                  <button onClick={stopScan} className="btn btn-outline-danger p-3 shadow mb-3 rounded" style={{ fontWeight: "bold", fontSize: "1.2em", minWidth: "80px" }}>Stop</button>
                  <button onClick={resetScan} className="btn btn-outline-secondary p-3 shadow mb-3 rounded" style={{ fontWeight: "bold", fontSize: "1.2em", minWidth: "80px" }}>Reset</button>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td width="100">Scan Speed:</td>
                        <td><input type="range" min="0.5" max="30" step="0.5" className="slider" style={{ width: "100%" }} value={scanFrequency} onChange={(e) => updateSliderValue(e.target.value)} id="scan_slider_timer" /></td>
                        <td style={{ width: "80px" }}><span id="range_value" style={{ textAlign: "center", fontWeight: "500", fontSize: "0.9em" }}>{scanFrequency}</span><b>sec</b></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr />
            <div className="horizontal-form p-0 m-0">
              <div className="form-group m-0 p-0">
                <label htmlFor="currentBaseCoin" className="form-label pt-1">Stable Base Coin</label>
                <div className="form-range" style={{ fontWeight: "bold", padding: "0px", fontSize: "1em" }}>
                  <span className="" id="currentBaseCoin">{userConfig.coinBase.toUpperCase()}</span>
                </div>
              </div>
              <div className="form-group m-0 p-0" style={{ height: "auto" }}>
                <label htmlFor="intervals2" className="form-label pt-1">Intervals</label>
                <div className="form-control p-0 m-0" style={{ justifyContent: "left", alignItems: "left", border: "0px", fontWeight: "bold", fontSize: "1em" }}>
                  <div className="d-flex flex-wrap m-0 p-0">
                    {userIntervals.map((interval) => (
                      <div key={interval} className="border rounded-1 interval-box" id={`interval-${interval}`}>{interval}</div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <label htmlFor="file">
              <i className="bi bi-binoculars"></i> Now checking...  
              <span id="txt_checking" className="blueChecking"></span>,&nbsp;&nbsp;
              <span id="span_txt_interval" className="blueChecking"></span>
            </label>
            <br />
            <progress id="txt_progress" max="100" value="0" style={{ width: "100%", height: "20px" }}></progress>
            <br />
            Total pairs &nbsp;&nbsp;<span id="txt_symbolIndex" className="blueChecking">0</span> of <span className="blueChecking" id="txt_totalpares">0</span>
            <div id="mensaje" className="alert alert-primary mt-1" role="alert">Process Info</div>
            <h1 className="border-bottom border-top mt-4"><div className="p-2">Results</div></h1>
            <div style={{ overflow: "hidden" }}>
              <div className="text-center p-2" style={{ fontWeight: "bold", fontSize: "1em" }}>
                <div className="row">
                  <div className="col">
                    <div className="card mb-4 rounded-3 shadow-sm border-secondary" style={{ width: "150px" }}>
                      <div className="card-header py-2 text-bg-warning border-warning"><h4 className="my-0 fw-normal">Round</h4></div>
                      <div className="card-body"><span id="round_count" className="title">0</span></div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="card mb-4 rounded-3 shadow-sm border-primary" style={{ width: "150px" }}>
                      <div className="card-header py-2 text-bg-primary border-primary"><h4 className="my-0 fw-normal">Founded</h4></div>
                      <div className="card-body"><span id="found_count" className="title">0</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="container_1"></div>
              <div id="result_analisis"></div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Scanfree;